import React from 'react';
import ReactDOM from 'react-dom';
import { create as createJss } from 'jss';
import { JssProvider } from 'react-jss';
import { createGenerateClassName, jssPreset } from '@material-ui/core/styles';
import './index.css';
import App from './App';
import * as serviceWorker from './serviceWorker';

// Sem um insertionPoint fixo, o JSS injeta o <style> de cada componente na
// ordem em que ele é renderizado pela primeira vez na sessão — em produção
// (sem reload a cada navegação, diferente do hot-reload local) isso
// acumula: uma tela visitada depois pode sobrescrever o CSS de uma visitada
// antes, e o layout vai quebrando progressivamente conforme se navega pelo
// app. O <meta id="mui-jss-insertion-point"> em public/index.html é o
// ponto fixo onde tudo isso passa a ser inserido, sempre na mesma ordem —
// tem que ser um elemento de verdade, não um comentário: o build de
// produção do CRA remove comentários do HTML na minificação.
const generateClassName = createGenerateClassName();
const jss = createJss({
  ...jssPreset(),
  insertionPoint: document.getElementById('mui-jss-insertion-point'),
});

ReactDOM.render(
  <JssProvider jss={jss} generateClassName={generateClassName}>
    <App />
  </JssProvider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
